import { render, staticRenderFns } from "./FullPageDigiCourseViewer.vue?vue&type=template&id=38f7363d&"
import script from "./FullPageDigiCourseViewer.vue?vue&type=script&lang=js&"
export * from "./FullPageDigiCourseViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports